import React from 'react';
import arrow from '../../../images/icons/ic-arrow.svg';
import { formatDistance } from '../../../src/js/lib/distance';

const SegmentSearchItem = ({ segment }) => {
  return (
    <a
      href={segment.url}
      className='flex justify-between w-full border-b border-border-secondary last:border-none px-4 md:px-6 py-12pt hover:bg-background-quinary'
    >
      <div className='flex flex-1 items-center min-w-0'>
        <span className='flex h-6 w-6 mr-1 text-body-inverted rounded-full justify-center items-center bg-primary shrink-0'>
          {segment.segment_type_icon_url && (
            <img src={segment.segment_type_icon_url} className='h-4' alt='' />
          )}
        </span>
        <div className='min-w-0 ml-3'>
          <h5 className='truncate m-0 mt-4pt font-text body-text'>
            {segment.name}
          </h5>
          <p className='truncate m-0 mini-text text-text-grey-600'>
            {formatDistance(segment.distance_in_meters)}
          </p>
        </div>
      </div>
      <div className='flex items-center'>
        <span>
          <img src={arrow} className='w-4' alt='' />
        </span>
      </div>
    </a>
  );
};

export default SegmentSearchItem;
